// @flow
import React, { useState } from 'react';
import { Col, Modal, Row } from 'antd';
import { SpH5, SpButton, SpError } from 'components/DesignKit';
import KYCFileUpload from 'components/KycFileUpload';
import { API_END_POINTS } from 'api';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedDocument: Object,
};

const UploadDocument = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedDocument,
  } = props;

  const [error, setError] = useState(false);
  const [url, setUrl] = useState(null);

  const onSubmit = () => {
    if (!url) {
      setError(true);
      return;
    }
    submit(url);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={onSubmit} type="primary">Save</SpButton>,
      ]}
      title="Upload Document"
    >
      <div className="px-4">
        <Row type="flex" justify="start" align="middle" className="mt-3">
          <Col span={8}>
            <span>Choosed File Type</span>
          </Col>
          <Col span={8}>
            <SpH5 className="pb-3">
              <div>{selectedDocument.friendlyName}</div>
            </SpH5>
          </Col>
        </Row>
        <Row type="flex" justify="start" align="middle" className="mt-3">
          <Col span={8}>
            <span>Upload the file</span>
          </Col>
          <Col span={8}>
            <KYCFileUpload
              name="Address"
              endPoint={API_END_POINTS.UPLOAD_KYC_DOCUMENT}
              url={url}
              keyType="PAYPAL_VERIFICATION"
              setUrl={value => setUrl(value)}
              type="Business"
            />
            <SpError>
              {error && 'File is required'}
            </SpError>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default UploadDocument;
